import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/tasksConstants';

const initialState = {
  tasks: [],
  task: null,
  loading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    search: '',
    page: 0,
    size: 10,
  },
};

const tasksReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_TASKS:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_TASK:
      return {
        ...state,
        task: null,
      };
    case types.GET_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        tasks: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_TASKS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_TASKS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_TASK:
      return {
        ...state,
        task: payload,
      };
    case types.SET_TASKS_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_TASKS_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          search: payload,
        },
      };
    case types.NEXT_TASKS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_TASKS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default tasksReducer;
